import React, { createContext, ReactElement, useState, Dispatch, SetStateAction, useEffect } from "react";
import { CampoDinamicoType, TipoCampoDinamicoType } from "./types";

interface CampoDinamicoContextProps {
  camposDinamicos: CampoDinamicoType[];
  setCamposDinamicos: Dispatch<SetStateAction<CampoDinamicoType[]>>;
  listaCamposDinamicos: CampoDinamicoType[];
  setListaCamposDinamicos: Dispatch<SetStateAction<CampoDinamicoType[]>>;
  campoDinamicoSelecionado: CampoDinamicoType;
  setCampoDinamicoSelecionado: Dispatch<SetStateAction<CampoDinamicoType>>;
  tiposCamposDinamicos: TipoCampoDinamicoType[];
  setTiposCamposDinamicos: Dispatch<SetStateAction<TipoCampoDinamicoType[]>>;
  handleAdicionarCampoDinamico: (campoDinamico:CampoDinamicoType) => void;
  handleAtualizarCampoDinamico: (idCampoDinamico:number, campoDinamico:CampoDinamicoType) => void;
  handleRemoveCampoDinamico: (idCampoDinamico:number) => void;
  resolveNomeCampoDinamico: (idCampo:number|string, padrao?:string) => string;
}

export const CampoDinamicoContext = createContext({} as CampoDinamicoContextProps);

export function CampoDinamicoProvider({ children }: { children: ReactElement }) {
  const [camposDinamicos, setCamposDinamicos] = useState<CampoDinamicoType[]>([] as CampoDinamicoType[])
  const [mapCamposDinamicos, setMapCamposDinamicos] = useState<Map<number, CampoDinamicoType>>();
  const [listaCamposDinamicos, setListaCamposDinamicos] = useState<CampoDinamicoType[]>([] as CampoDinamicoType[])
  const [campoDinamicoSelecionado, setCampoDinamicoSelecionado] = useState({} as CampoDinamicoType)
  const [tiposCamposDinamicos, setTiposCamposDinamicos] = useState<TipoCampoDinamicoType[]>([] as TipoCampoDinamicoType[]);

  useEffect(()=>{
    const novoMapa = new Map();
    camposDinamicos.forEach((campo) => {
      novoMapa.set(Number(campo.id_campo_dinamico), campo);
    });
    setMapCamposDinamicos(novoMapa);
  },[camposDinamicos])
  
  const handleAdicionarCampoDinamico = (campoDinamico:CampoDinamicoType)=>{
    setListaCamposDinamicos((current) => [campoDinamico, ...current]);
    if(camposDinamicos?.length){
      setCamposDinamicos((current) => [campoDinamico, ...current])
    }
  }

  const handleAtualizarCampoDinamico = (idCampoDinamico:number, campoDinamico:CampoDinamicoType) => {
    setListaCamposDinamicos((current) => {
      return current.map((item) => {
         if(item?.id_campo_dinamico === idCampoDinamico){
           return campoDinamico;
         }
         return item;
      })
    })
    if(camposDinamicos?.length){
      setCamposDinamicos((current)=>{
        return current.map((item) => {
           if(item?.id_campo_dinamico === idCampoDinamico){
             return campoDinamico;
           }
           return item;
        })
      })
    }
  }

  const handleRemoveCampoDinamico = (idCampoDinamico:number) => {
    setListaCamposDinamicos((current) => current.filter((item) => item.id_campo_dinamico !== idCampoDinamico));
    if(camposDinamicos?.length){
      setCamposDinamicos((current) => current.filter((item) => item.id_campo_dinamico !== idCampoDinamico));
    }
  }

  const resolveNomeCampoDinamico = (idCampo:number|string, padrao = "Não Atribuído") => {
    let campo = mapCamposDinamicos?.get(Number(idCampo));
    return (campo && campo?.label) || padrao;
  };

  return (
      <CampoDinamicoContext.Provider
        value={{
          camposDinamicos,
          setCamposDinamicos,
          tiposCamposDinamicos,
          setTiposCamposDinamicos,
          campoDinamicoSelecionado,
          setCampoDinamicoSelecionado,
          handleAdicionarCampoDinamico,
          handleAtualizarCampoDinamico,
          handleRemoveCampoDinamico,
          listaCamposDinamicos,
          setListaCamposDinamicos,
          resolveNomeCampoDinamico
        }}
      >
          {children}
      </CampoDinamicoContext.Provider>
  );
}
